import moment from 'moment';

import { ProgramItem, SLOT_DURATION_MINUTES } from './types';

/** Formate un créneau "YYYY-MM-DD HH:mm" en "… HH:mm → HH:mm" (fin = début + durée) */
export function formatSlotRange(slot?: string): string {
  if (!slot) return '';
  const start = moment(slot, 'YYYY-MM-DD HH:mm');
  if (!start.isValid()) return slot;
  const end = start.clone().add(SLOT_DURATION_MINUTES, 'minutes');
  return `${start.format('dddd D MMMM YYYY - HH:mm')} → ${end.format('HH:mm')}`;
}

/** Libellé lisible d'un élément de programme (chaîne brute ou objet) */
export function getProgramLabel(item: ProgramItem): string {
  if (typeof item === 'string') return item;
  return item.label || item.name || item.title || item.value || item._id || '';
}
